import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getSiriusWorkOrderHistory = createAsyncThunk('/GetSiriusWorkOrderHistory', async (WorkOrderId) => {
  const response = await axios.get(`/GetSiriusWorkOrderHistory/${WorkOrderId}`);
  return response.data;
});

const workOrderHistorySlice = createSlice({
  name: 'workOrderHistory',
  initialState: {
    loading: '',
    error: '',
    data: []
  },
  reducers: {
  },
  extraReducers: {
    [getSiriusWorkOrderHistory.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getSiriusWorkOrderHistory.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getSiriusWorkOrderHistory.fulfilled]: (state, action) => {
      state.WorkOrderInformation = action.payload;
      state.loading = 'Finished';
    }
  }
});

export const workOrderHistoryActions = workOrderHistorySlice.actions;

export default workOrderHistorySlice;
